import React, { useState, useEffect, useContext } from "react";
import {store} from '../../../context/store';

import { useHistory } from "react-router-dom";

import { functions } from "../../../constants/common-functions";

import Header from "../../../components/Header";
import LeftMenu from "../../../components/LeftMenu";

import ProgressGrid from "./components/ProgressGrid";
import DeskDrawer from "./components/DeskDrawer";
import ProgressBarChart from "./components/ProgressBarChart";

import MetricTogglePills from "../../../components/MetricTogglePills";
import UtilisationFooter from "../components/UtilisationFooter";

import {EMPTY_FILTER_BEAN} from "../../../constants/filter-constants";

import {
    METRIC_UTILISATION_CONFIG
}
from "../../../constants/metric-config";


import {
  METRIC_UTILISATION_UTILISATION,
  METRIC_UTILISATION_BOOKED,
  METRIC_UTILISATION_NO_SHOW,
  METRIC_UTILISATION_GHOST
} from "../../../constants/metrics";

export default function UsageInspector() {

    const history = useHistory();
	const globalState = useContext(store);

    const [data, setData] = useState(null);

    const [loading, setLoading] = useState(true);

    const [error, setError] = useState(false);

    const [selectedDesk, setSelectedDesk] = useState(null);

    const [activities, setActivities] = useState([]);
	
	const [metric, setMetric] =
	    useState(METRIC_UTILISATION_UTILISATION);
		
	const filterBean = {};
		
	const queryContext =
		    globalState?.state?.queryContext;

		

    // --------------------------------------------------------
    // LOAD SUMMARY ONLY
    // --------------------------------------------------------

    useEffect(function () {

        functions.getArrayFromAjax(
            "/resolutionsoftwareplatform/usageinspector/usageactivities",
            setActivities,
            null
        );

    }, []);
	
	
	useEffect(
	    function ()
	    {
	       

	        loadSummary();

	    },
	    [
	        metric,
	        queryContext?.utilisationSurveyId
	    ]
	);

    function loadSummary() {

        setLoading(true);

        functions.postFilterBeanAjax(

            "/resolutionsoftwareplatform/usageinspector/summary?metric=" + metric,
			functions.buildPostBodyFilterBeanQueryContext(filterBean, queryContext),
            function (response) {

                console.log(response);

                setData(response);

                setLoading(false);

            },

           null
        );
    }

    // --------------------------------------------------------
    // STYLES
    // --------------------------------------------------------

    const thisContainer = {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        minHeight: "100vh",
		background:"rgba(255, 255, 255, 0.5)"
    };

	const header =
	{
	    display:
	        "flex",
	    position:
	        "fixed",
	    width:
	        "700px",
	    left:
	        "calc(50% - 350px)",
	    top:
	        "0px",
	    zIndex:
	        30000,

	    justifyContent:
	        "center",
	    alignItems:
	        "center",

	    height:
	        "50px",

	    color:
	        "rgba(255,255,255,0.84)",

	    //--------------------------------------------------------
	    // OmniScan Flat title bar
	    //--------------------------------------------------------
	    background:
	        "linear-gradient(180deg,#171b20 0%,#0c0f12 100%)",

	    borderRadius:
	        "0px",

	    borderLeft:
	        "1px solid rgba(255,255,255,0.06)",

	    borderRight:
	        "1px solid rgba(255,255,255,0.06)",

	    borderBottom:
	        "2px solid #20afe8",

	    boxShadow:
	        "0 8px 20px rgba(0,0,0,0.20)",

	    overflow:
	        "hidden"
	};

    const titleContainer = {
        display: "flex",
        alignItems: "center",
        marginRight: "0px",
        fontSize: "16px",
        color: "lightgrey"
    };

    const contentContainer = {
        marginTop: "60px",
        marginLeft: "80px",
        padding: "20px",
        overflow: "auto",
		width:'calc(100% - 140px)',
    };

    // --------------------------------------------------------
    // RENDER
    // --------------------------------------------------------

    return (

        <div style={thisContainer}>

            <LeftMenu />

            <Header title="Usage Inspector"  showSurveySelector = {true}/>

            {/* ------------------------------------------------ */}
            {/* TOP HEADER */}
            {/* ------------------------------------------------ */}

            <div style={header}>

                <div style={titleContainer}>
                    Usage Inspector - Full Survey
                </div>

            </div>

            {/* ------------------------------------------------ */}
            {/* MAIN CONTENT */}
            {/* ------------------------------------------------ */}

            <div style={contentContainer}>

                {/* ------------------------------------------------ */}
                {/* LOADING */}
                {/* ------------------------------------------------ */}

                {loading && (

                    <div
                        style={{
                            padding: "20px",
                            color: "black"
                        }}
                    >
                        Loading usage summary...
                    </div>

                )}

                {/* ------------------------------------------------ */}
                {/* ERROR */}
                {/* ------------------------------------------------ */}

                {!loading && error && (

                    <div
                        style={{
                            padding: "20px",
                            color: "red"
                        }}
                    >
                        Error loading data
                    </div>

                )}

                {/* ------------------------------------------------ */}
                {/* NO DATA */}
                {/* ------------------------------------------------ */}

                {!loading && !error && (!data || !data.floors) && (

                    <div
                        style={{
                            padding: "20px",
                            color: "black"
                        }}
                    >
                        No data available
                    </div>

                )}

                {/* ------------------------------------------------ */}
                {/* CONTENT */}
                {/* ------------------------------------------------ */}

                {!loading && !error && data && data.floors && (

                    <div>
					<MetricTogglePills
					    metrics={METRIC_UTILISATION_CONFIG}
					    selectedMetric={metric}
					    onChange={setMetric}
					/>
                        <ProgressBarChart
                            data={data.summary}
							metric={metric}
                        />

                       
                        <ProgressGrid
                            floors={data.floors}
                            dates={data.dates}
                            onDeskClick={setSelectedDesk}
                            workplaceActivities={activities}
							metric={metric}
                        />
                       
						<div style={{height:'100px'}}/>
                    </div>

                )}

            </div>

            {/* ------------------------------------------------ */}
            {/* DRAWER */}
            {/* ------------------------------------------------ */}

            <DeskDrawer
                desk={selectedDesk}
                onClose={function () {

                    setSelectedDesk(null);

                }}
                workplaceActivities={activities}
            />
			<UtilisationFooter/>
        </div>
    );
}